import type { SpriteDefinition } from '@/render/spriteBaker';
import { PALETTE } from '@/sprites/palette';

/**
 * A spirit bolt: 8x8, small and bright.
 *
 * Round rather than arrow-shaped so it needs no per-facing art — a bolt that
 * looks the same flying in any direction is one sprite instead of four, and
 * nothing about it reads as wrong.
 */
export const BOLT_SPRITE: SpriteDefinition = {
  name: 'spirit-bolt',
  rows: [
    '..4444..',
    '.444444.',
    '44444444',
    '44444444',
    '44444444',
    '44444444',
    '.444444.',
    '..4444..',
  ],
  palette: PALETTE,
};
